import ExtendedPath from "csi/core/ExtendedPath";
import { CustomViewAttributesOptions } from "csi/middleware/customView/attributes/CustomViewAttributesStore";
import PropertyWidget from "csi/property/Widget";
import declare from "dojo/_base/declare";

const OMIT_ITEM_PRODUCT_TYPES = new Set([
	"Food",
	"FormulatedMaterial",
]);

const ECPropertiesCustomViewController = declare(PropertyWidget, { 
	/**
	 * @override
	 * Do not resolve any derived classes
	 */
	onCustomViewAttributeOptions(options: CustomViewAttributesOptions): void {
		this.inherited(arguments);
		options.omitContainerCallback = (extendedPath: ExtendedPath): boolean => OMIT_ITEM_PRODUCT_TYPES.has(extendedPath.endType);
	},
});

export = ECPropertiesCustomViewController;